<template>
    <v-card>
        <v-img height="80" src="@/assets/images/fondo1.png">
            <v-row class="pa-4" align="center" justify="center">
                <v-col fluid>
                    <v-list-item-avatar color="yellow" size="40" class="ma-0">
                        <v-icon size="30">receipt</v-icon>
                    </v-list-item-avatar>
                    <span class="headline black--text ma-4">Ticket</span>
                    <v-btn @click.prevent="fuAdd" color="primary"><v-icon>add</v-icon> Agregar</v-btn>
                    <!-- <v-btn @click.native="dCrmTicketModalDialog = true" color="primary"><v-icon>add</v-icon> Agregar</v-btn> -->
                </v-col>
            </v-row>
        </v-img>
        <v-overlay :value="dLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
        </v-overlay>
        <!-- <v-dialog v-model="dCrmTicketModalDialog" fullscreen hide-overlay>
            <v-card>
                <v-toolbar color="primary">
                    <v-toolbar-title dark>Ticket - Agregar</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="dCrmTicketModalDialog = false" icon><v-icon>close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text>
                    <CrmTicketAdd />
                </v-card-text>
            </v-card>
        </v-dialog> -->
        <v-dialog v-model="dPriAlumnoModalDialog" persistent max-width="900px">
            <v-card>
                <v-card-title style="background-color:#455A64">
                    <v-form ref="refPriAlumno">
                        <v-row fluid>
                            <v-col cols="9" xm="12" sm="9" md="9" class="pa-1">
                                <v-text-field @keyup.enter="fuPriAlumnoSearch" v-model="dDNINombre" label="DNI o Codigo o Nombre" outlined prepend-inner-icon="credit_card" clearable :rules="[v => !!v || 'El campo es requerido']" :maxlength="120" counter autocomplete="off"></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-btn @click="fuPriAlumnoSearch" :loading="dPriAlumnoTable.loading" color="blue-grey" dark x-large>
                                    <v-icon large left>search</v-icon> Buscar por {{coCampoTipo}}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-title>
                <v-data-table
                    v-model="dPriAlumnoTable.selected"
                    :headers="dPriAlumnoTable.headers"
                    :items="dPriAlumnos"
                    :loading="dPriAlumnoTable.loading"
                    single-select
                    item-key="IdAlumno"
                    show-select
                    class="elevation-1">
                    <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
                </v-data-table>
                <v-card-actions class="blue-grey darken-2">
                    <v-btn @click="fuPriAlumnoSelected()" color="green" dark><v-icon>check</v-icon> Seleccionar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="dPriAlumnoModalDialog = false" color="grey darken-4" dark><v-icon>close</v-icon> Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-tabs v-model="dTab" background-color="primary">
            <v-tab @click="dIsSearch=true;" href='#tab-1'><v-icon left>search</v-icon>Ticket</v-tab>
            <v-tab v-if="!dIsSearch" href='#tab-2'>AGREGAR</v-tab>
            <v-tab @click="dIsSearch=true;" href='#tab-3'><v-icon left>search</v-icon>Compromiso</v-tab>
            <v-tab-item value='tab-1'>
                <v-form>
                    <v-container fluid>
                        <v-row fluid>
                            <v-col cols="12" sm="6" md="4" lg="3" class="pa-0">
                                <v-menu v-model="dFInicioMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dFInicio"
                                            label="Fecha Inicio"
                                            prepend-inner-icon="event_note"
                                            readonly
                                            filled
                                            :disabled="dIsUpdating"
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="dFInicio"
                                        @input="dFInicioMenu = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" class="pa-0">
                                <v-menu v-model="dFFinMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dFFin"
                                            label="Fecha Fin"
                                            prepend-inner-icon="event_note"
                                            readonly
                                            filled
                                            :disabled="dIsUpdating"
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="dFFin"
                                        @input="dFFinMenu = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" class="pa-0">
                                <v-autocomplete label="Creado por:" v-model="dSearch.id_operador"
                                    :items="dPriPersonals" item-value="IdKhipuPlus" item-text="Personal"
                                    filled prepend-inner-icon="assignment_ind" :disabled="dIsUpdating" clearable>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" class="pa-0">
                                <v-autocomplete label="Derivado a:" v-model="dSearch.id_asignado"
                                    :items="dPriPersonals" item-value="IdKhipuPlus" item-text="Personal"
                                    filled prepend-inner-icon="assignment_ind" :disabled="dIsUpdating" clearable>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" class="pa-0">
                                <v-autocomplete label="Tipo" v-model="dSearch.id_tipo"
                                    :items="dCrmTicketTipos" item-value="id" item-text="nombre" persistent-hint
                                    filled prepend-inner-icon="invert_colors" :disabled="dIsUpdating" clearable>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" class="pa-0">
                                <v-text-field v-model="dSearch.detalle"
                                    prepend-inner-icon="receipt"
                                    label="Titulo Ticket" filled clearable
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" class="pa-0">
                                <v-btn @click.prevent="fuSearch" :loading="dTable.loading" color="blue-grey" dark x-large><v-icon large left>search</v-icon> Buscar</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
                <v-data-table :headers="dTable.headers" :items="dCrmTickets" :loading="dTable.loading" :search="dTable.search" class="elevation-1">
                    <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
                    <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda "{{ dTable.search }}".</v-alert></template>
                    <template v-slot:[`item.id`]="{ item }">
                        <v-btn @click="$router.push(`/TicketItem/${item.id}`);" color="success" text>{{item.id}}</v-btn>
                    </template>
                    <template v-slot:[`item.crmcliente`]="{ item }">
                        <span v-if="item.crmcliente.id_tipo==1">{{item.crmcliente.prialumno.Alumno}} - Codigo:{{item.crmcliente.prialumno.Codigo}} - DNI: {{item.crmcliente.prialumno.DNI}}</span>
                        <span v-else>{{item.crmcliente.admvisita.Visitante}} - DNI:{{item.crmcliente.admvisita.Dni}}</span>
                    </template>
                </v-data-table>
            </v-tab-item>
            <v-tab-item value='tab-2'>
                <v-row>
                    <v-col cols="3">
                        <v-card>
                            <v-img src="@/assets/images/fondo1.png" height="150px">
                                <v-app-bar flat color="rgba(0, 0, 0, 0)">
                                    <v-toolbar-title class="title white--text pl-0">Alumno</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="dPriAlumnoModalDialog = true" rounded x-small dark color="blue-grey">
                                        <v-icon>search</v-icon> Buscar
                                    </v-btn>
                                </v-app-bar>
                                <v-row justify="space-around">
                                    <v-avatar size="80">
                                        <img v-if="dPriAlumno.Sexo=='F'" src="@/assets/images/user2.jpg" alt="Alumno">
                                        <img v-else src="@/assets/images/user1.jpg" alt="Postulante">
                                    </v-avatar>
                                </v-row>
                            </v-img>
                            <v-list two-line v-if="dPriAlumno.Alumno">
                                <v-list-item>
                                    <v-list-item-icon><v-icon>person</v-icon></v-list-item-icon>
                                    <v-list-item-content><v-list-item-subtitle>{{dPriAlumno.Alumno}}</v-list-item-subtitle><v-list-item-subtitle>Apellidos y Nombres</v-list-item-subtitle></v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon><v-icon>bookmark</v-icon></v-list-item-icon>
                                    <v-list-item-content><v-list-item-title>{{dPriAlumno.Servicio}}</v-list-item-title><v-list-item-subtitle>Carrera</v-list-item-subtitle></v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon><v-icon>credit_card</v-icon></v-list-item-icon>
                                    <v-list-item-content><v-list-item-title>{{dPriAlumno.DNI}}</v-list-item-title><v-list-item-subtitle>DNI</v-list-item-subtitle></v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon><v-icon>qr_code_2</v-icon></v-list-item-icon>
                                    <v-list-item-content><v-list-item-title><v-chip color="success" dark>{{dPriAlumno.Codigo}}</v-chip></v-list-item-title><v-list-item-subtitle>Codigo</v-list-item-subtitle></v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-col>
                    <v-col cols="9">
                        <v-form ref="refMain">
                            <v-card color="blue-grey" dark flat :loading="dIsUpdating">
                                <v-card-text fluid>
                                    <v-row dense>
                                        <v-col cols="12" xm="12" sm="12" md="8">
                                            <v-autocomplete label="* Tipo" v-model="dCrmTicket.id_tipo"
                                                :items="dCrmTicketTipos" item-value="id" item-text="nombre" persistent-hint
                                                filled prepend-inner-icon="invert_colors" :disabled="dIsUpdating" :rules="[v => !!v || 'El campo es requerido']">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" xm="12">
                                            <v-textarea v-model="dCrmTicket.detalle" label="* Titulo Ticket"
                                                prepend-inner-icon="receipt" outlined rows="2" row-height="15" :rules="[v => !!v || 'El campo es requerido']"
                                            ></v-textarea>
                                        </v-col>
                                        <v-col cols="12" xm="12">
                                            <v-card color="primary">
                                                <v-card-text>
                                                    <v-col cols="12" xm="12" sm="12" md="8">
                                                        <v-autocomplete label="* Asignar a:" v-model="dCrmTicket.id_asignado"
                                                            :items="dPriPersonals" item-value="IdKhipuPlus" item-text="Personal"
                                                            filled prepend-inner-icon="assignment_ind" :disabled="dIsUpdating" :rules="[v => !!v || 'El campo es requerido']">
                                                        </v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="12" xm="12">
                                                        <v-textarea v-model="dCrmTicketComentario_mensaje" label="* Mensaje"
                                                            prepend-inner-icon="message" outlined rows="2" row-height="15" :rules="[v => !!v || 'El campo es requerido']"
                                                        ></v-textarea>
                                                    </v-col>
                                                    <v-col cols="12" xm="12">
                                                        <input style="display: none" type="file" @change="onFileSelected" ref="fileInput" accept="image/*" >
                                                        <v-btn @click.prevent="$refs.fileInput.click()"><v-icon left>cloud_upload</v-icon> Subir Imagen</v-btn>
                                                        <v-img max-height="139" max-width="250" :src="coImagen"></v-img>
                                                    </v-col>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn @click.prevent="fuSave" :loading="dIsUpdating" color="primary" ><v-icon>save</v-icon> Crear Ticket</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-form>
                    </v-col>
                </v-row>
            </v-tab-item>
            <v-tab-item value='tab-3'>
                <CrmCompromisoSearch />
            </v-tab-item>
        </v-tabs>

        <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
            <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
        </v-snackbar>
    </v-card>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import CrmTicketAdd from '@/components/Crm/CrmTicketAdd.vue';
import CrmCompromisoSearch from '@/components/Crm/CrmCompromisoSearch.vue';

export default {
    name: 'Ticket',
    components: {CrmTicketAdd, CrmCompromisoSearch},
    mounted(){
        this.fuLoad();
        this.dCrmTicket.id_operador = this.dSearch.id_operador = this.ssUser.IdKhipuPlus;
    },
    data: () => ({
        dIsUpdating: false,
        dLoading: false,
        dSnackbar: false,
        dCrmTicket: {
            id_operador: '',
            id_asignado: '',
            detalle: '',
            id_estado: 1,
            id_tipo: '',
        },
        dCrmTickets: [],
        dCrmTicketTipos: [],
        dCrmTicketComentario_mensaje: '',
        dCrmTicketModalDialog: true,
        dDNINombre:'',
        dFInicio: moment().format('YYYY-MM-DD'),
        dFInicioMenu: false,
        dFFin: moment().format('YYYY-MM-DD'),
        dFFinMenu: false,
        dIsSearch: true,
        dImagenMiniatura: '',
        dPriAlumno: {
            IdAlumno: '',
            DNI: '',
            Alumno: '',
            Sexo: '',
            Telefono: '',
            Codigo: '',
            Celular: '',
            Servicio: ''
        },
        dPriAlumnos: [],
        dPriAlumnoModalDialog: false,
        dPriAlumnoTable: {
            headers: [
                {value: 'actions', text: '...', sortable: false},
                {value: 'IdAlumno', text: 'IdAlumno', align: ' d-none'},
                {value: 'Alumno', text: 'Alumno'},
                {value: 'DNI', text: 'DNI', align: 'center', sortable: false},
                {value: 'Codigo', text: 'Codigo'},
                {value: 'priservicio.Iniciales', text: 'Carrera', align: 'center', sortable: false},
                {value: 'Celular', text: 'Celular', align: 'center', sortable: false},
                {value: 'Telefono', text: 'Telefono', align: 'center', sortable: false},
                {value: 'Sexo', text: 'Sexo', align: ' d-none'},
            ],
            loading: false,
            selected: []
        },
        dPriPersonals: [],
        dSelectedFile: null,
        dSearch: {
            id_operador: '',
            id_asignado: '',
            detalle: '',
            id_estado: 1,
            id_tipo: '',
        },
        dTab:0,
        dTable: {
            headers: [
                {value: 'id', text: 'Nro'},
                {value: 'created_at', text: 'F. Creacion'},
                {value: 'crmcliente', text: 'Cliente'},
                {value: 'crmtickettipo.nombre', text: 'Tipo'},
                {value: 'crmticketestado.nombre', text: 'Estado'},
                {value: 'detalle', text: 'Titulo'},
                {value: 'pripersonal.Personal', text: 'Creado por'},
                {value: 'pripersonal_asignado.Personal', text: 'Derivado a'},
            ],
            loading: false,
            search: null,
        },
    }),
    computed: {
        ...mapState(['ssUser']),
        coCampoTipo: function () {
            if(this.dDNINombre==''){
                return '';
            } else {
                if(this.dDNINombre.length==8 && !isNaN(this.dDNINombre))
                    return 'DNI';
                else{
                    if(this.dDNINombre.length==9 && !isNaN(this.dDNINombre.substring(0,5)))
                        return 'Codigo';
                    else
                        return 'Nombre';
                }
            }
        },
        coImagen(){
            return this.dImagenMiniatura;
        }
    },
    methods: {
        async fuLoad(){
            try {
                const response = await this.$apollo.query({
                    query: gql`query {
                        crmtickettipos{
                            id
                            nombre
                        }
                        pripersonalKhipuPlus{
                            IdKhipuPlus
                            Personal
                        }
                    }`
                })
                this.dCrmTicketTipos = response.data.crmtickettipos;
                this.dPriPersonals = response.data.pripersonalKhipuPlus;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Problema de Conexión.', 'error');
            } finally {
            }
        },
        fuAdd(){
            this.dPriAlumno = Object.assign({}, this.dPriAlumnoDefault);
            this.dIsSearch=false;
            this.dTab='tab-2';
        },
        fuPriAlumnoSearch(){
            if(this.dDNINombre==''){
                this.dSnackbar = true;
            } else {
                if(this.dDNINombre.length==8 && !isNaN(this.dDNINombre))
                    this.fuPrialumnoByDNI(this.dDNINombre)
                else{
                    if(this.dDNINombre.length==9 && !isNaN(this.dDNINombre.substring(0,5)))
                        this.fuPrialumnoByCodigo(this.dDNINombre)
                    else
                        this.fuPrialumnoByAlumno(this.dDNINombre)
                }
            }
        },
        async fuPrialumnoByCodigo(pCodigo) {
            this.dPriAlumnoTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByCodigo($Codigo: String!){
                        prialumnoByCodigo(Codigo: $Codigo){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        Codigo: pCodigo
                    }
                })
                console.log(response.data.prialumnoByCodigo);
                this.dPriAlumnos = [];
                this.dPriAlumnos.push(response.data.prialumnoByCodigo);
            } catch (error) {
                console.log(error);
            } finally {
                this.dPriAlumnoTable.loading = false
            }
        },
        async fuPrialumnoByDNI(pDni) {
            this.dPriAlumnoTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByDNI($DNI: String!){
                        prialumnoByDNI(DNI: $DNI){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        DNI: pDni
                    }
                })
                console.log(response.data.prialumnoByDNI);
                this.dPriAlumnos = response.data.prialumnoByDNI;
            } catch (error) {
                console.log(error);
            } finally {
                this.dPriAlumnoTable.loading = false
            }
        },
        async fuPrialumnoByAlumno(pAlumno) {
            this.dPriAlumnoTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByAlumno($Alumno: String!){
                        prialumnoByAlumno(Alumno: $Alumno){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        Alumno: pAlumno
                    }
                })
                console.log(response.data.prialumnoByAlumno);
                this.dPriAlumnos = response.data.prialumnoByAlumno;
            } catch (error) {
                console.log(error);
            } finally {
                this.dPriAlumnoTable.loading = false
            }
        },
        fuPriAlumnoSelected(){
            if(!this.dPriAlumnoTable.selected){
                Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
            } else {
                if(this.dPriAlumnoTable.selected.length==0)
                    Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
                else{
                    this.dPriAlumno.IdAlumno = this.dPriAlumnoTable.selected[0].IdAlumno;
                    this.dPriAlumno.DNI = this.dPriAlumnoTable.selected[0].DNI;
                    this.dPriAlumno.Alumno = this.dPriAlumnoTable.selected[0].Alumno;
                    this.dPriAlumno.Sexo = this.dPriAlumnoTable.selected[0].Sexo;
                    this.dPriAlumno.Telefono = this.dPriAlumnoTable.selected[0].Telefono;
                    this.dPriAlumno.Codigo = this.dPriAlumnoTable.selected[0].Codigo;
                    this.dPriAlumno.Celular = this.dPriAlumnoTable.selected[0].Celular;
                    this.dPriAlumno.Servicio = this.dPriAlumnoTable.selected[0].priservicio.Iniciales;
                    this.dPriAlumnoModalDialog = false;
                }
            }
        },
        fuSave(){
            if(!this.$refs.refMain.validate() || this.dPriAlumno.IdAlumno==''){
                this.dSnackbar = true;
            } else {
                this.fuCreate();
            }
        },
        async fuCreate () {
            try {
                this.dIsUpdating = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation crmticketCreateIdAlumno($IdAlumno: ID!, $mensaje: String, $file: Upload, $input: crmticketCreateInput!){
                        crmticketCreateIdAlumno(
                            IdAlumno:$IdAlumno,
                            mensaje: $mensaje,
                            file: $file, 
                            input: $input)
                        {
                            id
                        }
                    }`,
                    variables: {
                        IdAlumno: this.dPriAlumno.IdAlumno,
                        mensaje: this.dCrmTicketComentario_mensaje,
                        file: this.dSelectedFile,
                        input: this.dCrmTicket
                    },
                    context: {
                        hasUpload: true
                    }
                });
                if(response.data){
                    console.log(response.data);
                    Swal.fire('Correcto', 'Se guardó correctamente', 'success');
                    this.$router.push(`/`);
                } else {
                    Swal.fire('¡ ERROR !', 'No se guardó.', 'error');
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
            } finally {
                this.dIsUpdating = false;
            }
        },
        onFileSelected(event) {
            // this.dSelectedFile = event.target.files[0];
            this.dSelectedFile = this.$refs.fileInput.files[0];
            
            let reader = new FileReader();
            reader.onload = (e) => {
                this.dImagenMiniatura = e.target.result;
            }
            reader.readAsDataURL(this.dSelectedFile);
        },
        async fuSearch(){
            this.dTable.loading = true;
            let vFInicio =this.dFInicio.substring(0,10).split("-").join("");
            let vFFin =this.dFFin.substring(0,10).split("-").join("");
            let vid_operador = this.dSearch.id_operador ? this.dSearch.id_operador:'';
            let vid_asignado = this.dSearch.id_asignado ? this.dSearch.id_asignado:'';
            let vid_tipo = this.dSearch.id_tipo ? this.dSearch.id_tipo:'';
            let vdetalle = this.dSearch.detalle ? this.dSearch.detalle:'';
            try {
                const response = await this.$apollo.query({
                    query: gql`query crmticketSearch($FInicio: String!, $FFin: String!, $id_operador: String, $id_asignado: String, $detalle: String, $id_tipo: String, $token: String){
                        crmticketSearch(FInicio:$FInicio, FFin:$FFin, id_operador:$id_operador, id_asignado:$id_asignado, detalle:$detalle, id_tipo:$id_tipo, token: $token){
                            id
                            detalle
                            created_at
                            updated_at
                            crmcliente{
                                id_tipo
                                prialumno{
                                    Alumno
                                    Codigo
                                    DNI
                                }
                                admvisita{
                                    Visitante
                                    Dni
                                }
                            }
                            crmtickettipo{
                                nombre
                            }
                            crmticketestado{
                                nombre
                            }
                            pripersonal{
                                Personal
                            }
                            pripersonal_asignado{
                                Personal
                            }
                        }
                    }`,
                    variables: {
                        FInicio: vFInicio,
                        FFin: vFFin,
                        id_operador: vid_operador,
                        id_asignado: vid_asignado,
                        detalle: vdetalle,
                        id_tipo: vid_tipo,
                        token: new Date().toISOString()
                    }
                })
                console.log(response.data.crmticketSearch);
                this.dCrmTickets = [];
                this.dCrmTickets = response.data.crmticketSearch;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dTable.loading = false
            }
        },
    }
}
</script>